export class Principal {
    ID: number;
    PrincipalCode: string;
    PrincipalName: string;
    PrincipalContact: string;
    PrincipalAddress: string;
    PrincipalPhone: string;
    PrincipalFax: string;
    Notes: string;
    Discount: string;
}
